module.exports = __webpack_public_path__ + "img/sixday1-2.8f27d4ff.jpg";